import React, { Component } from "react";
import { Avatar, Divider } from "@mui/material";
import { Box } from "@mui/system";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { IconButton } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import "../../styles/blinkingbutton.css";
import { color } from "@material-ui/system";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { Button, Container, Paper, Stack } from "@mui/material";
import { ChevronRightRounded, MoreHoriz } from "@mui/icons-material";

import { HelpOutlineOutlined } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

import axios from "axios";
import { getURLBase, updateParentHeight } from "../../utils/helperFns";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export class AccountsItem extends Component {
  constructor(props) {
    super(props);
    this.reauthUrl = getURLBase(true) + "/reauthurl";

    this.state = {
      transaction: {},
      renewClicked: false,
      open: false,
    };
  }

  static defaultProps = {
    handleClick: null,
  };

  toggleRenew = () => {
    var renewClicked = this.state.renewClicked;
    renewClicked = !renewClicked;
    this.setState({ showAllAccounts: renewClicked });

    console.log(renewClicked, "scjknsasdfklnsajkdnasklnda");
  };

  reauth = () => {
    console.log(this.props.transaction.connectionID, "ashdsakjdnkjsahdasjkd");

    axios
      .post(this.reauthUrl, {
        connection: this.props.transaction.connectionID,
        gid: this.props.gid,
      })
      .then((response) => {
        console.log(response.data.body, "reauth check");

        const { url } = response.data.body || {};

        if (url) {
          var win = window.open(url, "_self");

          win.focus();
        }
        // this.processData(response.data.body);
      });
  };

  render() {
    return (
      <>
        <Dialog
          open={this.state.open}
          onClose={() => this.setState({ open: false, embelUrl: "" })}
          sx={{ borderRadius: "30px" }}
        >
          <DialogTitle
            sx={{
              fontSize: "1rem",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              margin: 0,
            }}
          >
            Required Under Open Banking Rules.
            <IconButton
              aria-label="close"
              onClick={() => this.setState({ open: false, embelUrl: "" })}
              sx={{
                padding: 0,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseRoundedIcon />
            </IconButton>
          </DialogTitle>
          <Divider light />
          <CardContent sx={{ width: "40vw" }} className="tutorial-container">
            <Typography color="inherit" style={{ fontSize: 10 }}>
              Every 90 days you need to reconnect your bank account to Wyzr so
              that you can see your updated information. Please renew your
              access if you would like this service to provide you with updated
              information.
            </Typography>
          </CardContent>
        </Dialog>

        <Grid
          container
          mt={1}
          mb={2}
          spacing={2}
          justifyContent="space-between"
          alignItems="flex-end"
          className={this.props.transaction.name === null ? "blur" : ""}
        >
          <Grid item xs>
            <Grid container alignItems="center">
              <Grid item>
                <Avatar
                  style={{ height: 50, width: 50 }}
                  sx={{ backgroundColor: "grey.100" }}
                >
                  <Box sx={{ fontWeight: "bold" }} color="primary.main">
                    <Typography style={{ fontSize: 18 }} color="text.secondary">
                      {this.props.transaction.name.slice(0, 1)}
                    </Typography>
                  </Box>
                </Avatar>
              </Grid>
              <Grid item xs>
                <Typography style={{ fontSize: 18, marginLeft: 10 }}>
                  {this.props.transaction.name}
                </Typography>
                {this.props.transaction.type !== "INVALID" ? (
                  <Typography
                    style={{ fontSize: 14, marginLeft: 10 }}
                    color="text.secondary"
                  >
                    {this.props.transaction.type
                      ? this.props.transaction.type
                      : "N.A"}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs>
            <Grid
              container
              spacing={1}
              direction="column"
              style={{
                paddingTop: 10,
                backgroundColor: "#FFF",
                backgroundRepeat: "no-repeat",
              }}
            >
              <Grid item>
                <Box>
                  <Button
                    variant="outlined"
                    fontWeight="800"
                    style={{
                      fontSize: 12,
                      height: 25,
                      backgroundColor: "red",
                      color: "#FFF",
                      borderWidth: 0,
                      marginLeft: 5,
                    }}
                    textTransformtype="capitalize"
                    onClick={() => this.reauth()}
                    // onClick={this.props.toggleTransactionScreen}
                    endIcon={<ChevronRightRounded />}
                  >
                    Renew
                  </Button>
                </Box>
              </Grid>
              <Grid item display={"inline"}>
                <button
                  onClick={() => this.setState({ open: true })}
                  // disabled={renderProps.disabled}
                  style={{
                    display: "flex",
                    backgroundColor: "#FFF",
                    borderWidth: 0,
                  }}
                >
                  <>
                    <HelpOutlineOutlined
                      style={{ width: 18, height: 18, color: "#9e9e9e" }}
                    />

                    <Typography
                      display="inline"
                      style={{
                        fontSize: 12,
                        marginLeft: 5,
                        color: "#9e9e9e",
                        fontWeight: 700,
                      }}
                    >
                      Why do I need to Renew?
                    </Typography>
                  </>
                </button>
              </Grid>
            </Grid>

            {/* {this.props.transaction.renewal_needed ? (
              <button
                onClick={() => this.toggleRenew()}
                type="submit"
                class="button"
              >
                Renew Now
              </button>
            ) : (
              <button
                style={{
                  backgroundColor: "green",
                  color: "#FFF",
                  borderRadius: 5,
                  fontSize: 16,
                }}
                onClick={() => this.toggleRenew()}
                type="submit"
              >
                Active
              </button>
            )} */}
          </Grid>
        </Grid>
        <Divider light />
      </>
    );
  }
}

export default AccountsItem;
